import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-content">
        <div className="footer-left" data-testid="footer-copyright">
          © 2026 ./v8
        </div>
        <div className="footer-right" data-testid="footer-quote">
          patience. precision. presence.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
